var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.21875,
    width: 24,
    height: 24,
    rx: 5.625,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4697 17.3519L16.3273 9.77696C16.6456 9.36847 16.7588 8.8962 16.6527 8.41533C16.5607 7.97817 16.2919 7.56251 15.8887 7.24719L14.9053 6.46604C14.0493 5.78523 12.9882 5.85689 12.3798 6.63804L11.7218 7.49157C11.637 7.59835 11.6582 7.75601 11.7643 7.84201C11.7643 7.84201 13.4268 9.17497 13.4621 9.20364C13.5753 9.31114 13.6602 9.45447 13.6815 9.62646C13.7168 9.96329 13.4834 10.2786 13.1367 10.3216C12.974 10.3431 12.8184 10.2929 12.7052 10.1998L10.9578 8.80948C10.8729 8.7457 10.7456 8.75932 10.6748 8.84532L6.52218 14.2202C6.25335 14.557 6.16138 14.9942 6.25335 15.417L6.78393 17.7174C6.81223 17.8393 6.91834 17.9253 7.04568 17.9253L9.38023 17.8966C9.80469 17.8894 10.2009 17.6959 10.4697 17.3519ZM13.7385 16.6355H17.5452C17.9167 16.6355 18.2187 16.9415 18.2187 17.3178C18.2187 17.6947 17.9167 18 17.5452 18H13.7385C13.3671 18 13.065 17.6947 13.065 17.3178C13.065 16.9415 13.3671 16.6355 13.7385 16.6355Z",
    fill: "#6948BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareEditPen);
export default __webpack_public_path__ + "static/media/squareEditPen.369f56b1e42ce800ab596cf1427d9edc.svg";
export { ForwardRef as ReactComponent };